import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, Subject, of, BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import {
    SqlQueryBuilderService,
    PlatformDataService,
    EcapLoginService,
    UserInfoService,
    ShellDomainProvider,
    EcapCoreUserAccessManagementService
} from '../../core';
import { isNull, filter, forEach, map as _map, indexOf } from 'lodash';
import { UpdateUserCommand, CreateUserCommand } from '../models/platform-user-access-management.model';
import { UAMProfileImageUploadService } from '../services/platform-profile-image-upload.service';

@Injectable()
export class PlatfromUserAccssManagementService implements OnDestroy {
    onUserUpdated = new Subject<any>();
    OnUserCreated = new Subject<any>();
    OnUserDeleted = new Subject<any>();
    OnClickCreateUser = new Subject<any>();
    OnClickDataTableRow = new Subject<any>();
    OnLoadDynamicCreateComponent = new Subject<any>();
    ToResendActivationEmail = new Subject<any>();
    OnViewUpdated = new Subject<any>();
    OnPayloadUpdate: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    OnGetCustomUserList: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    refCreateUserComponent: any;
    uamConfig: any;
    commonOptions: any = { headers: this.header, withCredentials: true, observe: 'response' };
    constructor(
        private http: HttpClient,
        private ecapCoreUserAccessManagementService: EcapCoreUserAccessManagementService,
        private sqlQueryBuilderService: SqlQueryBuilderService,
        private platformDataService: PlatformDataService,
        private UAMProfileImageUploadService: UAMProfileImageUploadService,
        private userInfoService: UserInfoService,
        private router: Router,
        private ecapLoginService: EcapLoginService
    ) {}

    subscribe() {
        this.OnPayloadUpdate = new BehaviorSubject<any>(false);
        this.OnGetCustomUserList = new BehaviorSubject<any>(false);
    }
    setUamConfig(uamConfig) {
        this.uamConfig = uamConfig;
    }
    getUamConfig() {
        return this.uamConfig;
    }

    getViews(): any {
        return {
            list: 'list',
            createUser: 'createUser',
            editUser: 'editUser'
        };
    }
    updateRoute(view, userId) {
        this.OnViewUpdated.next(view);
        this.router.navigate([location.pathname], {
            queryParams: {
                view: view,
                userId: userId || null
            }
        });
    }

    OnCreateUser(userModel) {
        this.OnClickCreateUser.next(userModel);
    }
    OnUpdateUser(dataTableRow) {
        this.OnClickDataTableRow.next(dataTableRow);
    }
    OnUserUpdate(User) {
        this.onUserUpdated.next(User);
    }
    OnNewUserCreated(User) {
        this.OnUserCreated.next(User);
    }
    OnDeleteUser(User) {
        this.OnUserDeleted.next(User);
    }
    ResendActivationEmail() {
        this.ToResendActivationEmail.next(true);
    }
    getTableData(payload) {
        this.OnPayloadUpdate.next(payload);
    }
    getCustomUserList(payload) {
        this.OnGetCustomUserList.next(payload);
    }

    getUserList(searchkey, seletedSearchByPropertyName, requestData): any {
        if (
            requestData.SearchFilters &&
            seletedSearchByPropertyName &&
            ((typeof searchkey == 'string' && searchkey) || typeof searchkey == 'boolean' || Array.isArray(searchkey))
        ) {
            requestData.SearchFilters[seletedSearchByPropertyName] = searchkey;
        }
        return this.ecapCoreUserAccessManagementService.getUserList(requestData).pipe(
            switchMap((response: any) => {
                if (response && response['body']) {
                    return this.getProfileImageOfUsers(response['body']);
                } else {
                    return null;
                }
            }),
            map((responseUsers: any) => {
                return responseUsers;
            })
        );
        // return this.ecapCoreUserAccessManagementService.getUserList(requestData).pipe(switchMap(response => {
        //     if (requestData && requestData.PropertyFromPerson && requestData.PropertyFromPerson.length) {
        //         return this.getPersonsInfoOfUsers(response && response["body"], requestData.PropertyFromPerson);
        //     } else {
        //         return of(response && response["body"]);
        //     }
        // }), map(response => response));
    }
    getProfileImageOfUsers(userList): any {
        let propertyList = _map(this.uamConfig.Datatable.Columns, 'prop');
        let showProfileImage =
            (this.uamConfig &&
                !this.uamConfig.needExtraUserInfo &&
                propertyList &&
                indexOf(propertyList, 'ProfileImageId') > -1) ||
            (this.uamConfig && this.uamConfig.ProfileImageConfig && this.uamConfig.ProfileImageConfig.ShowProfileImage);
        if (showProfileImage) {
            if (
                this.uamConfig &&
                this.uamConfig.ProfileImageConfig &&
                this.uamConfig.ProfileImageConfig.ProfileImageTag
            ) {
                return this.UAMProfileImageUploadService.getProfileImageResourse(
                    userList,
                    this.uamConfig.ProfileImageConfig.ProfileImageTag
                ).pipe(
                    map((personWithProfileImages: any) => {
                        return personWithProfileImages;
                    })
                );
            } else {
                return this.UAMProfileImageUploadService.getProfileImageFiles(userList).pipe(
                    map((responseProfileImages: any) => {
                        return responseProfileImages;
                    })
                );
            }
        } else {
            return of(userList);
        }
    }
    setProfileImageOfUser(userList, personWithProfileImages) {
        personWithProfileImages &&
            personWithProfileImages.forEach(person => {
                userList &&
                    userList.Users &&
                    userList.Users.forEach(user => {
                        if (user.ItemId == person.CreatedBy) {
                            user.Uri = person.Uri;
                        }
                    });
            });
        return userList;
    }
    getPersonsInfoOfUsers(users, personsProperty) {
        let userIds = _map(users && users.Users, 'ItemId');
        return this.getPersonsByUserIds(userIds, personsProperty).pipe(
            map(responsePersons => {
                return this.getDenomUsers(users, responsePersons, personsProperty);
            })
        );
    }
    getDenomUsers(users, responsePersons, personsProperty) {
        forEach(personsProperty, property => {
            forEach(responsePersons && responsePersons.Results, person => {
                forEach(users && users.Users, user => {
                    if (user.ItemId === person.CreatedBy) {
                        if (property === 'ItemId') {
                            user['PersonId'] = person[property];
                        } else {
                            user[property] = person[property];
                        }
                        return;
                    }
                });
            });
        });
        return users;
    }
    getPersonsByUserIds(userIds, personsProperty) {
        let filterQuery = [];
        filterQuery.push({
            property: 'CreatedBy',
            operator: '|',
            value: userIds.join(',')
        });
        indexOf(personsProperty, 'CreatedBy') > -1 ? personsProperty : personsProperty.push('CreatedBy');
        return this.getPersonInfo(personsProperty, filterQuery, userIds).pipe(
            map(response => {
                return response && response['body'];
            })
        );
    }

    getPersonInfo(personsProperty, filterQuery, userIds): any {
        let connectionFilterQuery = [];
        connectionFilterQuery.push({
            property: 'ParentEntityID',
            operator: '|',
            value: userIds.join(',')
        });
        connectionFilterQuery.push({
            property: 'ParentEntityName',
            operator: '=',
            value: 'User'
        });
        connectionFilterQuery.push({
            property: 'ChildEntityName',
            operator: '=',
            value: 'Person'
        });
        let connectionQuery = this.sqlQueryBuilderService.prepareQuery(
            'Connection',
            ['ChildEntityID', 'ChildEntityName', 'ParentEntityID', 'ParentEntityName'],
            connectionFilterQuery,
            null,
            0,
            10
        );

        return new Observable(observer => {
            this.platformDataService.getBySqlFilter('Connection', connectionQuery).subscribe(responseConnection => {
                let responseConnectionData = [];
                if (
                    responseConnection['body'] &&
                    responseConnection['body']['Results'] &&
                    responseConnection['body']['Results'].length > 0
                ) {
                    responseConnectionData = responseConnection['body']['Results'];

                    //? get person data
                    let personFilterQuery = [];
                    personFilterQuery.push({
                        property: 'ItemId',
                        operator: '|',
                        value: responseConnectionData.map(item => {
                            return item.ChildEntityID;
                        })
                    });

                    let query = this.sqlQueryBuilderService.prepareQuery(
                        'Person',
                        personsProperty,
                        personFilterQuery,
                        null,
                        0,
                        userIds && userIds.length
                    );
                    this.platformDataService.getBySqlFilter('Person', query).subscribe(responsePersonData => {
                        observer.next(responsePersonData);
                    });
                } else {
                    observer.next(null);
                }
            });
        });

        // let query = this.sqlQueryBuilderService.prepareQuery("Person",personsProperty,filterQuery,null,0, userIds && userIds.length);
        // return this.platformDataService.getBySqlFilter("Person", query).pipe(map(response=>{
        //      return response;
        // }));
    }

    getPersonIdByUserId(userId: string): Observable<any> {
        let connectionFilterQuery = [];
        connectionFilterQuery.push({
            property: 'ParentEntityID',
            operator: '=',
            value: userId
        });
        connectionFilterQuery.push({
            property: 'ParentEntityName',
            operator: '=',
            value: 'User'
        });
        connectionFilterQuery.push({
            property: 'ChildEntityName',
            operator: '=',
            value: 'Person'
        });

        let connectionQuery = this.sqlQueryBuilderService.prepareQuery(
            'Connection',
            ['ChildEntityID', 'ChildEntityName', 'ParentEntityID', 'ParentEntityName'],
            connectionFilterQuery,
            null,
            0,
            1
        );

        return new Observable(observer => {
            this.platformDataService.getBySqlFilter('Connection', connectionQuery).subscribe(responseConnection => {
                let responseConnectionData = {};
                if (
                    responseConnection['body'] &&
                    responseConnection['body']['Results'] &&
                    responseConnection['body']['Results'].length > 0
                ) {
                    responseConnectionData = responseConnection['body']['Results'][0]['ChildEntityID'];
                    observer.next(responseConnectionData);
                } else {
                    observer.next(null);
                }
            });
        });
    }
    getUsersRoles(filters) {
        let rolesFilter = {
            Filters: (filters && filters.length && this.getRolesFilter(filters)) || []
        };
        return this.ecapCoreUserAccessManagementService
            .getRoles(rolesFilter)
            .pipe(map(response => response && response['body']));
    }
    private getRolesFilter(filters) {
        return _map(
            filter(filters, filter => filter && filter.Tag && !isNull(filter && filter.Tag)),
            'Tag'
        );
    }
    resendActivationEmail(userId) {
        return this.ecapCoreUserAccessManagementService.ResendActivationEmail(userId).pipe(map(response => response));
    }
    getUserInfoById(userId): any {
        return this.ecapCoreUserAccessManagementService
            .GetUserById(userId)
            .pipe(map(response => response && response['body']));
    }

    public getPersonByUserId(userId): any {
        let filterQuery = [];
        filterQuery.push({
            property: 'CreatedBy',
            operator: '|',
            value: userId
        });
        const personFields = [
            ...ShellDomainProvider['api'].PersonFields,
            "CompanyName",
            "Street",
            "StreetNumber",
            "PostalCode",
            "City"
        ];

        return this.getPersonInfo(personFields, filterQuery, [userId]).pipe(
            map(response => response && response['body'])
        );
    }

    updateUser(userInfo: UpdateUserCommand): any {
        // userInfo = this.validateUserInfoForUpdate(userInfo);
        let validUserInfo = new UpdateUserCommand(userInfo, true);
        return this.ecapCoreUserAccessManagementService
            .UpdateUser(validUserInfo)
            .pipe(map(response => response && response['body']));
    }

    updatePerson(personInfo: any): any {
        return this.platformDataService
            .update('Person', personInfo)
            .pipe(map(response => response && response['body']));
    }
    // validateUserInfoForUpdate(userInfo){
    //     if(userInfo.hasOwnProperty('UserId')) return userInfo;
    //     else{
    //         userInfo.UserId = userInfo.ItemId;
    //         delete userInfo.ItemId;
    //     }
    //     return userInfo;
    // }
    isEmailExist(email): any {
        return this.ecapLoginService.emailExists(email).pipe(map(response => response && response['body']));
    }
    createUser(userInfo: CreateUserCommand) {
        let validUserInfo = new CreateUserCommand(userInfo, true);
        return this.ecapCoreUserAccessManagementService.CreateUser(validUserInfo).pipe(map(response => validUserInfo));
    }
    updateUserWithPersonInfo(userInfo) {
        userInfo.PersonInfo = {
            FirstName: (userInfo && userInfo.FirstName) || '',
            LastName: (userInfo && userInfo.LastName) || '',
            DisplayName:
                (userInfo && userInfo.DisplayName) ||
                (userInfo && userInfo.FirstName + ' ' + userInfo && userInfo.LastName),
            Tags: userInfo && userInfo.Tags && userInfo.Tags.length ? userInfo.Tags : ['Person'],
            Email: (userInfo && userInfo.Email) || '',
            PhoneNumber: userInfo && userInfo.PhoneNumber,
            Roles: userInfo && userInfo.Roles,
            Salutation: userInfo && userInfo.Salutation
        };
        if (this.uamConfig && this.uamConfig.PropertyOfPersonUpdate) {
            forEach(this.uamConfig.PropertyOfPersonUpdate, property => {
                if (!userInfo.PersonInfo.hasOwnProperty(property)) {
                    userInfo.PersonInfo[property] = (userInfo && userInfo[property]) || '';
                }
            });
        }
        return userInfo;
    }

    createUserValidationPayload(userInfo) {
        let validUserInfo = new CreateUserCommand(userInfo, true);
        return validUserInfo;
    }
    updateUserValidationPayload(userInfo) {
        let validUserInfo = new UpdateUserCommand(userInfo, true);
        return validUserInfo;
    }
    ngOnDestroy(): void {
        this.OnGetCustomUserList.unsubscribe();
        this.OnPayloadUpdate.unsubscribe();
    }
    unsubscribeSubscriptions() {
        this.ngOnDestroy();
    }
    subscribeSubscription() {
        this.subscribe();
    }
}
